
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tnpsc-namakkal",
      function () {
        return require("private-next-pages/tnpsc-namakkal/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tnpsc-namakkal"])
      });
    }
  